module.exports = "<div class=\"gw-padded\">\r\n    <ul>\r\n        <li ng-repeat=\"item in damagedParts track by code\">\r\n            <span>{{item.name}}</span>\r\n            <a ng-click='offDamage(item)'><span class=\"fa fa-trash\"></span></a>\r\n        </li>\r\n    </ul>\r\n    <div ng-show=\"damagedParts.length == 0\">\r\n        {{'fnol.ca.directives.damage-list.Select which part of the car was damaged.'| translate}}\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/fnol/ca/directives/templates/damage-list.html
// module id = 614
// module chunks = 0